
import { AlertSettings } from '../types';
import { KEYS } from './core';
import { supabase } from '../supabase';
import { getCurrentUserId } from '../supabase';

// Alert Settings
export const getAlertSettings = (): AlertSettings => {
  const data = localStorage.getItem(KEYS.ALERT_SETTINGS);
  return data 
    ? JSON.parse(data) 
    : { 
        enabled: true, 
        daysThreshold: 7, 
        emailNotifications: false,
        phoneNotifications: false
      };
};

export const setAlertSettings = (settings: AlertSettings): void => {
  localStorage.setItem(KEYS.ALERT_SETTINGS, JSON.stringify(settings));
};

// Check if notification should be sent for a product based on settings
export const shouldNotifyForProduct = (daysRemaining: number, settings: AlertSettings): boolean => {
  return settings.enabled && daysRemaining <= settings.daysThreshold;
};

// Send notifications based on settings
export const sendNotifications = async (
  productName: string, 
  daysRemaining: number, 
  productId: string,
  settings: AlertSettings
): Promise<{emailSent: boolean, inAppSent: boolean}> => {
  let emailSent = false;
  let inAppSent = false;
  
  if (!settings.enabled || daysRemaining > settings.daysThreshold) {
    return { emailSent, inAppSent };
  }
  
  console.log(`Low stock alert for ${productName}: ${daysRemaining} days remaining`);
  
  // Email notification
  if (settings.emailNotifications) {
    try {
      const userId = await getCurrentUserId();
      
      if (userId && productId) {
        // Call the Supabase Edge Function to send an email
        const { error } = await supabase.functions.invoke('send-low-stock-alert', {
          body: { productId, userId },
        });
        
        if (error) {
          console.error('Failed to send email notification:', error);
        } else {
          emailSent = true;
          console.log(`Email notification sent for ${productName}`);
        }
      }
    } catch (error) {
      console.error('Failed to send email notification:', error);
    }
  }
  
  // In-app notification
  if (settings.phoneNotifications) {
    try {
      // In a real app, this would trigger an in-app notification
      // For now, we'll just log it
      console.log(`In-app notification would be shown for ${productName}`);
      inAppSent = true;
    } catch (error) {
      console.error('Failed to show in-app notification:', error);
    }
  }
  
  return { emailSent, inAppSent };
};
